import { IMAGES } from "../../data/content";
import { FadeUp, SectionHead, ChapterTag } from "./Reveal";

const MARKETS = ["Asia", "Africa", "Middle East", "Europe"];

export default function Mauritius() {
    return (
        <section id="about" className="scroll-mt-20 bg-ivory py-24 text-navy-deep lg:py-36" data-testid="mauritius-section">
            <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                <ChapterTag light>Chapter 02 &mdash; Our Corporate Base</ChapterTag>

                <div className="mt-10 grid grid-cols-1 items-center gap-14 lg:grid-cols-2 lg:gap-20">
                    <div>
                        <SectionHead
                            light
                            eyebrow="Mauritius"
                            title="From Mauritius to Global Markets"
                        />
                        <FadeUp delay={0.1}>
                            <p className="mt-6 text-base leading-relaxed text-navy-deep/75 md:text-lg">
                                Viet Medica Ltd is registered in Mauritius, an internationally connected
                                island nation positioned between Africa and Asia. From our corporate base
                                in Mauritius, our wider network develops relationships across Asia, Africa,
                                the Middle East and Europe.
                            </p>
                            <p className="mt-5 text-base leading-relaxed text-navy-deep/75 md:text-lg">
                                Mauritius reflects the character of our group: multicultural, commercially
                                connected and outward-looking. Our international teams combine local market
                                knowledge with cross-border experience to support healthcare journeys,
                                strategic partnerships and responsible global trade.
                            </p>
                            <div className="mt-9 flex flex-wrap gap-3" data-testid="mauritius-market-tags">
                                {MARKETS.map((m) => (
                                    <span
                                        key={m}
                                        className="border border-navy-deep/20 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.24em] text-navy-deep/80"
                                    >
                                        {m}
                                    </span>
                                ))}
                            </div>
                        </FadeUp>
                    </div>

                    <FadeUp delay={0.15} className="relative">
                        <div className="relative mr-4 lg:mr-8">
                            <span className="absolute -bottom-4 -right-4 h-full w-full border border-gold lg:-bottom-6 lg:-right-6" aria-hidden="true" />
                            <img
                                src={IMAGES.mauritius}
                                alt="Turquoise lagoon and coastline of Mauritius from the air"
                                loading="lazy"
                                className="relative aspect-[4/5] w-full object-cover"
                                data-testid="mauritius-image"
                            />
                            <div className="absolute bottom-5 left-5 bg-navy-deep/85 px-4 py-2.5 backdrop-blur-sm">
                                <span className="text-[10px] font-semibold uppercase tracking-[0.3em] text-gold">
                                    Mauritius &mdash; Between Africa and Asia
                                </span>
                            </div>
                        </div>
                    </FadeUp>
                </div>
            </div>
        </section>
    );
}
